import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabservicepune() {



    const cardData = {

keyword: "Corporate Cab Service Pune",

headingDescription:
    "Rising Cab Service offers professional and reliable Corporate Cab Service Pune for businesses, IT companies, executives, and corporate employees. We provide comfortable local and outstation travel, airport transfers, client pickups, employee transportation, and business meeting travel with well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and premium vehicles. Our experienced chauffeurs, 24/7 availability, transparent pricing, and punctual service ensure a safe and hassle-free corporate travel experience for individuals and organizations across Pune.",

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is the financial capital of India and a major business destination from Pune. Corporate travelers frequently visit for client meetings, conferences, exhibitions, and business events at locations like BKC, Nariman Point, and Andheri."
    },
    {
        title: "Hinjewadi IT Park",
        description:
            "Hinjewadi IT Park is Pune's largest technology hub, housing multinational companies and corporate offices. It is a key destination for employee transportation and business travel."
    },
    {
        title: "Kharadi EON IT Park",
        description:
            "Kharadi is one of Pune's fastest-growing business districts with EON IT Park and the World Trade Center. It is a major destination for corporate meetings and office commutes."
    },
    {
        title: "Magarpatta City",
        description:
            "Magarpatta City is a prominent IT and commercial township with corporate offices, business parks, and modern infrastructure, making it a frequent destination for business travelers."
    },
    {
        title: "Pune Airport",
        description:
            "Pune Airport is an essential corporate travel hub connecting business professionals to major Indian cities. Airport pickup and drop services are among the most popular corporate cab requirements."
    },
    {
        title: "Pimpri Chinchwad MIDC",
        description:
            "Pimpri Chinchwad MIDC is a major industrial and manufacturing hub with automobile and engineering companies, attracting regular business and corporate travel."
    },
    {
        title: "Nashik",
        description:
            "Nashik is an important industrial and commercial city with manufacturing units, wineries, and business centers. Corporate travelers often visit for meetings and industrial tours."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a growing industrial city with major manufacturing plants and business zones, making it a popular corporate travel destination from Pune."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is a significant commercial and industrial city in Maharashtra known for manufacturing, agriculture, and business activities, attracting corporate visitors."
    },
    {
        title: "Goa",
        description:
            "Goa is a preferred destination for corporate conferences, team outings, incentive tours, and business events, offering a perfect combination of work and leisure travel."
    }
],



services: [
    {
        name: "Corporate Cab Service Pune",
        description:
            "Rising Cab Service provides Corporate Cab Service Pune for companies, IT parks, startups, and business organizations requiring safe and reliable employee transportation. Our corporate travel solutions include daily office commutes, employee pickup and drop, airport transfers, client visits, and business meetings. We offer well-maintained AC vehicles, experienced chauffeurs, GPS-enabled tracking, flexible scheduling, monthly billing options, and 24x7 customer support to ensure comfortable and punctual transportation for businesses of all sizes."
    },
    {
        name: "Business Cab Service Pune",
        description:
            "Our Business Cab Service Pune is designed for executives, entrepreneurs, and corporate professionals who require dependable transportation for meetings, conferences, client visits, and official travel. Rising Cab Service offers premium vehicles, professional drivers, flexible booking options, and reliable service to support business travel across Pune and nearby cities."
    },
    {
        name: "Employee Transport Pune",
        description:
            "Rising Cab Service offers Employee Transport Pune with organized pickup and drop solutions for offices, IT companies, factories, and corporate parks. Our employee transportation services improve convenience and punctuality while ensuring safe and comfortable travel with verified drivers and well-maintained vehicles."
    },
    {
        name: "Office Cab Service Pune",
        description:
            "Our Office Cab Service Pune provides dedicated transportation for daily office commuting, employee shifts, business meetings, and official events. Rising Cab Service ensures timely pickups, comfortable vehicles, and dependable travel solutions for companies and working professionals."
    },
    {
        name: "Corporate Taxi Pune",
        description:
            "Rising Cab Service offers Corporate Taxi Pune for executives and business travelers requiring professional and comfortable transportation. We provide local travel, airport transfers, and intercity business trips with premium service standards."
    },
    {
        name: "Company Cab Service Pune",
        description:
            "Our Company Cab Service Pune supports organizations with customized employee transportation plans including regular office travel, event transportation, and airport transfers. We offer reliable service with flexible booking and billing options."
    },
    {
        name: "Staff Transportation Pune",
        description:
            "Rising Cab Service provides Staff Transportation Pune for businesses looking for safe and efficient employee mobility solutions. Our fleet is suitable for daily office commuting and scheduled staff movement across Pune and surrounding areas."
    },
    {
        name: "Corporate Cab Booking Pune",
        description:
            "Book Corporate Cab Booking Pune with Rising Cab Service for official travel requirements including employee transportation, executive travel, airport transfers, and client meetings with easy scheduling and reliable service."
    },
    {
        name: "Executive Cab Service Pune",
        description:
            "Our Executive Cab Service Pune offers premium travel for senior management, business executives, and VIP guests. We provide luxury vehicles, professional chauffeurs, and punctual transportation for business travel."
    },
    {
        name: "Corporate Travel Cab Pune",
        description:
            "Rising Cab Service offers Corporate Travel Cab Pune for conferences, seminars, exhibitions, client visits, and business tours. We provide comfortable vehicles and professional service for seamless corporate travel."
    },
    {
        name: "Monthly Cab Service Pune",
        description:
            "Our Monthly Cab Service Pune provides long-term transportation contracts for companies and individual professionals. We offer cost-effective monthly plans for office commutes and employee transportation."
    },
    {
        name: "Employee Pickup Drop Pune",
        description:
            "Rising Cab Service provides Employee Pickup Drop Pune with scheduled and shift-based transportation services for IT companies, corporate offices, and industrial businesses ensuring timely and safe travel."
    },
    {
        name: "Corporate Fleet Pune",
        description:
            "Our Corporate Fleet Pune includes hatchbacks, sedans, SUVs, Innova Crysta, and premium vehicles suitable for executive travel, employee transportation, and business events with professional chauffeurs."
    },
    {
        name: "Premium Corporate Cab Pune",
        description:
            "Rising Cab Service offers Premium Corporate Cab Pune for business executives and VIP guests requiring luxury travel with high-end vehicles, experienced drivers, and premium comfort."
    },
    {
        name: "Office Commute Cab Pune",
        description:
            "Our Office Commute Cab Pune provides reliable daily transportation for employees and professionals with flexible timings and affordable corporate travel packages."
    },
    {
        name: "Corporate Cab Services in Pune",
        description:
            "Rising Cab Service provides Corporate Cab Services in Pune for organizations requiring safe, efficient, and professional transportation for employees, executives, and business guests."
    },
    {
        name: "Corporate Taxi Service Pune",
        description:
            "Our Corporate Taxi Service Pune offers dedicated business travel solutions for office commutes, airport transfers, meetings, and official events with comfortable vehicles and reliable drivers."
    },
    {
        name: "Employee Transportation Service Pune",
        description:
            "Rising Cab Service offers Employee Transportation Service Pune with customized pickup and drop schedules for companies, factories, and IT organizations ensuring safe and punctual travel."
    },
    {
        name: "Corporate Car Rental Pune",
        description:
            "Our Corporate Car Rental Pune provides vehicles on demand for business meetings, executive travel, conferences, and official events with flexible rental plans."
    },
    {
        name: "Corporate Travel Service Pune",
        description:
            "Rising Cab Service provides Corporate Travel Service Pune for business tours, client visits, and official travel with premium vehicles and professional chauffeurs."
    },
    {
        name: "Staff Pickup and Drop Service Pune",
        description:
            "Our Staff Pickup and Drop Service Pune ensures convenient and secure employee transportation with scheduled routes and dedicated corporate travel solutions."
    },
    {
        name: "Best Corporate Cab Service in Pune",
        description:
            "Rising Cab Service is known for providing one of the Best Corporate Cab Service in Pune with reliable vehicles, trained drivers, flexible corporate plans, and dedicated customer support."
    },
    {
        name: "Employee Transport Service Near Me Pune",
        description:
            "Book Employee Transport Service Near Me Pune with Rising Cab Service for dependable office transportation and staff mobility solutions across Pune and nearby areas."
    },
    {
        name: "Office Pickup and Drop Cab Pune",
        description:
            "Our Office Pickup and Drop Cab Pune provides safe and punctual transportation for working professionals and company employees with flexible scheduling."
    },
    {
        name: "Corporate Taxi Booking Pune",
        description:
            "Rising Cab Service offers Corporate Taxi Booking Pune for executives, business travelers, and company staff with instant booking and premium travel facilities."
    },
    {
        name: "Business Travel Cab Service Pune",
        description:
            "Our Business Travel Cab Service Pune supports official travel requirements with reliable vehicles, experienced chauffeurs, and professional transportation solutions."
    },
    {
        name: "Corporate Airport Cab Pune",
        description:
            "Rising Cab Service provides Corporate Airport Cab Pune for timely airport pickups and drops for executives, employees, and business guests with 24x7 availability."
    },
    {
        name: "Cab Service for Companies Pune",
        description:
            "Our Cab Service for Companies Pune offers complete transportation solutions for employee commuting, business meetings, official events, and airport transfers."
    },
    {
        name: "Staff Transportation in Pune",
        description:
            "Rising Cab Service provides Staff Transportation in Pune for organizations requiring secure, organized, and cost-effective employee mobility services."
    },
    {
        name: "Corporate Cab Service Pimpri Chinchwad",
        description:
            "Our Corporate Cab Service Pimpri Chinchwad offers employee transportation, office pickup and drop, executive travel, and business cab solutions for companies located across PCMC and nearby industrial and IT hubs."
    }
],

tableData: [
    ["Corporate Cab Service Pune", "Business Cab Service Pune"],
    ["Employee Transport Pune", "Office Cab Service Pune"],
    ["Corporate Taxi Pune", "Company Cab Service Pune"],
    ["Staff Transportation Pune", "Corporate Cab Booking Pune"],
    ["Executive Cab Service Pune", "Corporate Travel Cab Pune"],
    ["Monthly Cab Service Pune", "Employee Pickup Drop Pune"],
    ["Corporate Fleet Pune", "Premium Corporate Cab Pune"],
    ["Office Commute Cab Pune", "Corporate Cab Services in Pune"],
    ["Corporate Taxi Service Pune", "Employee Transportation Service Pune"],
    ["Corporate Car Rental Pune", "Corporate Travel Service Pune"],
    ["Staff Pickup and Drop Service Pune", "Best Corporate Cab Service in Pune"],
    ["Employee Transport Service Near Me Pune", "Office Pickup and Drop Cab Pune"],
    ["Corporate Taxi Booking Pune", "Business Travel Cab Service Pune"],
    ["Corporate Airport Cab Pune", "Cab Service for Companies Pune"],
    ["Staff Transportation in Pune", "Corporate Cab Service Pimpri Chinchwad"]
],




whychoose: [
    {
        WhyChooseheading: "Professional Corporate Transportation Solutions",
        WhyChoosedescription: "Rising Cab Service provides dedicated corporate cab services in Pune for businesses, IT companies, startups, manufacturing units, and corporate offices."
    },
    {
        WhyChooseheading: "Employee Pickup and Drop Services",
        WhyChoosedescription: "Our transportation solutions help organizations manage daily employee commuting with punctual pickups, route planning, and reliable travel arrangements."
    },
    {
        WhyChooseheading: "Suitable for Meetings and Business Visits",
        WhyChoosedescription: "Executives and corporate teams can utilize our cab services for client meetings, conferences, official visits, exhibitions, and business events."
    },
    {
        WhyChooseheading: "Wide Fleet for Corporate Requirements",
        WhyChoosedescription: "We offer Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles to accommodate varying business travel needs."
    },
    {
        WhyChooseheading: "Coverage Across Pune's Business Hubs",
        WhyChoosedescription: "Our corporate cab services are available in Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Magarpatta, Viman Nagar, Kothrud, Pimpri Chinchwad, and industrial areas."
    },
    {
        WhyChooseheading: "Flexible Corporate Travel Management",
        WhyChoosedescription: "Companies can arrange daily transportation, shift-based travel, airport transfers, guest transportation, and customized mobility solutions."
    },
    {
        WhyChooseheading: "Focus on Safety and Reliability",
        WhyChoosedescription: "Professional drivers, vehicle maintenance standards, and efficient trip coordination ensure dependable transportation for employees and management teams."
    },
    {
        WhyChooseheading: "Customized Contracts for Businesses",
        WhyChoosedescription: "Rising Cab Service offers tailored corporate transportation plans designed according to company size, workforce requirements, and operational schedules."
    }
]
};

const faqData = [
    {
        question: "Which organizations can benefit from corporate cab services in Pune?",
        answer: "IT companies, BPOs, manufacturing industries, startups, business parks, educational institutions, and corporate offices frequently use corporate transportation services."
    },
    {
        question: "Can companies arrange regular employee transportation?",
        answer: "Yes, daily pickup and drop facilities can be organized for employees working across different shifts and office locations."
    },
    {
        question: "Are airport transfer services available for corporate travelers?",
        answer: "Yes, executives, business guests, and employees can utilize dedicated airport pickup and drop services."
    },
    {
        question: "What vehicle categories are commonly used for corporate travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses are among the most frequently selected options."
    },
    {
        question: "Can transportation be arranged for corporate events and conferences?",
        answer: "Yes, we provide travel solutions for seminars, exhibitions, conferences, training sessions, and company events."
    },
    {
        question: "Do you serve IT parks and industrial zones in Pune?",
        answer: "Yes, our services cover Hinjewadi IT Park, EON IT Park, Magarpatta, SP Infocity, Chakan MIDC, Ranjangaon MIDC, and other business hubs."
    },
    {
        question: "Can businesses request dedicated vehicles for long-term use?",
        answer: "Yes, customized contracts can be arranged for dedicated vehicles and long-term transportation requirements."
    },
    {
        question: "Is transportation available for visiting clients and guests?",
        answer: "Yes, guest transportation services can be organized for business visitors, delegates, and corporate partners."
    },
    {
        question: "How do companies manage transportation during night shifts?",
        answer: "Shift-based transportation solutions can be planned according to employee schedules and operational requirements."
    },
    {
        question: "How can a company get started with corporate cab services?",
        answer: "Organizations can contact Rising Cab Service through phone, WhatsApp, or online inquiry to discuss transportation requirements and receive a customized proposal."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Deshmukh",
        feedback:
            "Managing employee transportation became significantly easier after partnering with Rising Cab Service. Their coordination, punctuality, and professionalism have consistently met our expectations.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priyanka Kulkarni",
        feedback:
            "Our organization regularly uses Rising Cab Service for executive travel and airport transfers. The service quality, vehicle standards, and operational support have been outstanding.",
        rating: 5
    }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Corporate Cab Service in Pune",
"image": "https://www.risingcabservice.com/assets/images/corporate-cab-service-pune.jpg",
"description": "Book Corporate Cab Service in Pune with Rising Cab Service for employee transportation, office commute, business travel, and staff pickup and drop services. Enjoy reliable, safe, and professional corporate taxi solutions.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/corporate-cab-service-pune"
}
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Pune | Employee Transport & Office Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Corporate Cab Service in Pune for employee transportation, office commute, staff pickup and drop, and business travel. Reliable corporate taxi solutions for companies and professionals."
/>

<meta
 name="keywords"
 content="Corporate cab service pune, business cab service pune, employee transport pune, office cab service pune, corporate taxi pune, company cab service pune, staff transportation pune, corporate cab booking pune, executive cab service pune, corporate travel cab pune, monthly cab service pune, employee pickup drop pune, corporate fleet pune, premium corporate cab pune, office commute cab pune, Corporate Cab Service Pune, Corporate Cab Services in Pune, Corporate Taxi Service Pune, Employee Transportation Service Pune, Corporate Car Rental Pune, Office Cab Service Pune, Business Cab Service Pune, Corporate Travel Service Pune, Staff Pickup and Drop Service Pune, Corporate Cab Booking Pune, best corporate cab service in Pune, Employee transport service near me"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporatecabservicepune;